import cn from 'classnames'
import Link from 'next/link'
import type {ReactNode} from 'react'
import type {TrackingProps} from 'src/common/helpers'
import {EVENTS, track} from 'src/common/helpers'
import type {UrlObject} from 'url'

export type ButtonProps = {
  children: ReactNode
  href?: string | UrlObject
  target?: string
  locale?: string
  onClick?: () => void
  variant?: 'solid' | 'outline'
  full?: boolean
  trackingData: Omit<TrackingProps, 'event'>
}

export const Button = ({
  children,
  href,
  target,
  locale,
  onClick,
  variant = 'solid',
  full = false,
  trackingData,
}: ButtonProps) => {
  const className = cn(
    'inline-flex items-center justify-center gap-2 rounded-control px-5 py-3 text-14 font-medium transition-colors',
    full && 'w-full',
    variant === 'solid' && 'bg-green-neon text-green-dark hover:bg-green-neon-deep',
    variant === 'outline' &&
      'border border-moss-white/[18%] text-green-mist hover:border-green-neon/50 hover:bg-green-neon/[7%]',
  )

  const handleClick = () => {
    track({event: EVENTS.CLICK, ...trackingData})
    onClick?.()
  }

  if (href) {
    return (
      <Link href={href} target={target} locale={locale} className={className} onClick={handleClick}>
        {children}
      </Link>
    )
  }

  return (
    <button type="button" onClick={handleClick} className={className}>
      {children}
    </button>
  )
}
